import { gql } from 'apollo-boost';

export const getPlanQuery = gql`
  query Plan($type: PlanType!) {
    Plan(input: { type: $type }) {
      price
      finalPrice
    }
  }
`;

export const requestForRenewPageQuery = gql`
  mutation RequestForRenewPage($pageId: ID) {
    RequestForRenewPage(input: { pageId: $pageId }) {
      paymentUrl
    }
  }
`;

export const requestForNewPageQuery = gql`
  mutation RequestForNewPage($count: Int!) {
    RequestForNewPage(input: { count: $count }) {
      paymentUrl
    }
  }
`;
